<p>Please enter details of your employment history, beginning with the most recent, including both full-time and part-time positions.
    (including temporary work, internships, etc.)</p>
    
<p>We recommend you use your CV to complete this section as Bank of America will require all periods of employment to be verified. Not disclosing information could lead to new requests for information as well as delays to your screening closure.</p>

<mat-divider aria-hidden="true"></mat-divider>

<mat-dialog-actions align="end">
    <button mat-raised-button class="close-button" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>